import { makeStyles } from "@material-ui/core";

const dataPlacement = makeStyles({
    root: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center"
    }
})

export default dataPlacement
